import { fetch2, baseURL, post, get } from "./api";

// 积分奖励列表
export function adsRewardList(params: any = {}) {
  return fetch2(baseURL + "/api/ads/rewardList", params);
}

// 回传广告观看信息
export function adsSubmitInfo(params: any = {}) {
  return fetch2(baseURL + "/api/ads/submitInfo", params);
}

// 获取推送列表
export function adsRewardStatus() {
  return post<{
    isChromeReviewed: boolean;
    isG2Reviewed: boolean;
    isAdsAvailable: boolean;
    isTotalLimited: boolean;
    totalRewardCredits: number;
    isLinkedCrmFollowed: boolean;
    isPostRewarded: boolean;
    finishAllReward: boolean;
    ecosystemSidebarEnabled: boolean;
  }>(baseURL + "/api/ads/rewardStatus");
}

export function getRewardInfo() {
  return get(baseURL + "/api/share/reward/info");
}
export function getRewardPotential() {
  return get(baseURL + "/api/share/reward/potential");
}
